import React, { forwardRef } from 'react';

import classnames from 'classnames';

import { type ChipGroup } from '../Chip.types';

import styles from '../Chip.module.scss';

type Props = {
    background?: boolean;
    children?: React.ReactNode;
    className?: string;
    group: ChipGroup;
};

export const GroupChip = forwardRef<HTMLDivElement, Props>(
    ({ background, children, className, group: { backgroundColor, initials } }: Props, ref) => {
        return (
            <div
                className={classnames(styles.chip, className, {
                    [styles['chip--no-background']]: !background
                })}
                ref={ref}
            >
                <span className={styles['chip-group']} style={{ backgroundColor }}>
                    {initials}
                </span>
                {children}
            </div>
        );
    }
);

GroupChip.displayName = 'GroupChip';
